import React from 'react';
import { useSelector } from 'react-redux';
import { storeTypes } from 'shared/reducer';
import Loading from 'components/loading';
import style from './style.module.scss';

const LayoutEmpty = ({ children }) => {
  const isLoading = useSelector((state: storeTypes) => state.isLoading);
  return (
    <div className={`${style['empty-layout']}`}>
      { isLoading && <Loading /> }
      { children }
    </div>
  );
};

export default LayoutEmpty;
